export default "__VITE_ASSET__f2d6fbeb__"